import { useRef, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
// import AddLeaveModal from "../../components/UI/AddLeaveModal";
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";
import axios from "axios";
import { getToken } from "../../../src/utils/tokenUtils";
import ReactPaginate from "react-paginate";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { AuthContext } from "../../contexts/AuthContext";
import DropdownMenu from "../../components/UI/DropdownMenu";
import { X, MoreVertical, AlertTriangle, Trash2, Edit3 } from "lucide-react";
import StatusBadge from "../../components/UI/StatusBadge";

const OutdoorDutyPage = () => {
  const { user } = useContext(AuthContext);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [requests, setRequests] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filter, setFilter] = useState("All");
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [notification, setNotification] = useState(null);
  const [formData, setFormData] = useState({
    from_date: "",
    to_date: "",
    start_day: "",
    start_half: "",
    last_day: "",
    last_half: "",
    leave_type: "OD",
    total_days: "",
    reason: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const token = getToken();
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    perPage: 15,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [leaveLoading, setLeaveLoading] = useState(false);
  const [error, setError] = useState("");
  const [total_days, setTotalDays] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);
  // filter
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [filteredData, setFilteredData] = useState(requests);

  const [tempFilters, setTempFilters] = useState({});
  const { roles } = useContext(AuthContext);

  const [openRow, setOpenRow] = useState(null);
  const buttonRef = useRef(null);

  const getRoleBasedRouteLocal = (route) => {
    return getRoleBasedRoute(route, roles);
  };

  // console.log("this is active filters: ", activeFilters)

  const toggleFilterMenu = () => {
    setShowFilterMenu(!showFilterMenu);
  };

  const handleFilterChange = (field, value) => {
    setActiveFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearFilters = () => {
    setActiveFilters({});
    setSearchQuery("");
  };

  const clearFilterByKey = (key) => {
    const updatedFilters = { ...activeFilters };
    delete updatedFilters[key];
    setActiveFilters(updatedFilters);
  };

  // Define the filterable columns based on your table structure
  const filterableColumns = [
    { field: "from_date", label: "From Date" },
    { field: "to_date", label: "To Date" },
    { field: "total_days", label: "Total Days" },
    { field: "status", label: "Status" },
  ];

  useEffect(() => {
    if (showFilterMenu) {
      setTempFilters(activeFilters);
    }
  }, [showFilterMenu]);

  useEffect(() => {
    setFilteredData(requests);
  }, [requests]);

  useEffect(() => {
    // Apply both search query and filters
    const normalizedRequests = requests.map((req) => ({
      ...req,
      status: req.request?.status || "",
    }));

    let result = normalizedRequests;

    // let result = requests;

    // Apply search query filtering
    if (searchQuery) {
      const lowercasedQuery = searchQuery.toLowerCase();
      result = result.filter((item) => {
        // Search across all relevant fields
        return (
          item.from_date?.toLowerCase().includes(lowercasedQuery) ||
          item.to_date?.toLowerCase().includes(lowercasedQuery) ||
          (item.total_days != null &&
            item.total_days
              .toString()
              .toLowerCase()
              .includes(lowercasedQuery)) ||
          item.status?.toLowerCase().includes(lowercasedQuery)
        );
      });
    }

    // Apply column-specific filters
    Object.entries(activeFilters).forEach(([field, filterValue]) => {
      if (filterValue) {
        result = result.filter((item) => {
          const value = item[field];
          if (field === "created_at" && value) {
            // Date filtering
            const itemDate = new Date(value);
            const day = String(itemDate.getDate()).padStart(2, "0");
            const month = String(itemDate.getMonth() + 1).padStart(2, "0");
            const year = itemDate.getFullYear();
            const formattedDate = `${day}-${month}-${year}`;

            return formattedDate.includes(filterValue);
          } else {
            // Standard string filtering
            return value
              ?.toString()
              .toLowerCase()
              .includes(filterValue.toLowerCase());
          }
        });
      }
    });

    const filteringNow =
      searchQuery.length > 0 || Object.values(activeFilters).some((v) => !!v);
    setIsFiltering(filteringNow);
    setFilteredData(result);
  }, [searchQuery, activeFilters, requests]);

  // working with half day count
  useEffect(() => {
    if (formData.from_date && formData.to_date) {
      const start = new Date(formData.from_date);
      const end = new Date(formData.to_date);

      if (start > end) {
        setTotalDays(0);
        setFormData((prev) => ({ ...prev, total_days: 0 }));
      } else {
        let daysDiff = (end - start) / (1000 * 60 * 60 * 24) + 1;

        // Subtract 0.5 for half day selections
        if (formData.start_day === "Half") {
          daysDiff -= 0.5;
        }
        if (
          formData.last_day === "Half" &&
          formData.from_date !== formData.to_date
        ) {
          daysDiff -= 0.5;
        }

        // Ensure not negative
        const finalDays = daysDiff < 0 ? 0 : daysDiff;

        setTotalDays(finalDays);
        setFormData((prev) => ({ ...prev, total_days: finalDays }));
      }
    } else {
      setTotalDays(0);
      setFormData((prev) => ({ ...prev, total_days: 0 }));
    }
  }, [
    formData.from_date,
    formData.to_date,
    formData.start_day,
    formData.last_day,
  ]);

  const fetchODRequests = async (page = 1) => {
    try {
      setLeaveLoading(true);
      const response = await axios.get(
        `https://hrmspayroll.prepstripe.com/api/od-requests?page=${page}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setLeaveLoading(false);
      const data = response.data; // Ensure correct data structure
      setRequests(data?.data || []);

      setPagination({
        currentPage: data?.current_page || 1,
        totalPages: data?.last_page || 1,
        totalItems: data?.total || 0,
        perPage: data?.per_page || 10,
      });
    } catch (error) {
      setLeaveLoading(false);
      console.error("Error fetching OD requests:", error);
      setNotification({
        message: `Error fetching OD requests:, ${error}`,
        type: "error",
      });
    }
  };

  // Fetch shift change requests from API
  useEffect(() => {
    fetchODRequests();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(`Updating ${name} to: `, value); // Debugging

    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
        ...(name === "start_day" && value === "Full" ? { start_half: "" } : {}),
        ...(name === "last_day" && value === "Full" ? { last_half: "" } : {}),
      };

      // If start_day is changed to "Half", default start_half to "First" unless user selects "Select an option"
      if (name === "start_day") {
        updatedData.start_half = value === "Half" ? "First" : "";
      }

      // If last_day is changed to "Half", default last_half to "First" unless user selects "Select an option"
      if (name === "last_day") {
        updatedData.last_half = value === "Half" ? "First" : "";
      }

      // Clear last_day and last_half if from_date and to_date are the same
      if (updatedData.from_date === updatedData.to_date) {
        updatedData.last_day = "";
        updatedData.last_half = "";
      }

      // Ensure to_date is not before from_date
      if (name === "from_date" && prev.to_date && prev.to_date < value) {
        updatedData.to_date = ""; // clear invalid to_date
      }

      if (name === "to_date" && prev.from_date && value < prev.from_date) {
        alert("To Date cannot be earlier than From Date.");
        return prev; // don't update state
      }

      return updatedData;
    });
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    // console.log(`Updating ${name} to: `, value); // Debugging

    setSelectedLeave((prev) => {
      if (!prev) return { [name]: value }; // Handle null case safely

      let updatedData = {
        ...prev,
        [name]: value,
        ...(name === "start_day" && value === "Full" ? { start_half: "" } : {}),
        ...(name === "last_day" && value === "Full" ? { last_half: "" } : {}),
      };

      // Clear last_day and last_half if from_date and to_date are the same
      if (updatedData.from_date === updatedData.to_date) {
        updatedData.last_day = "";
        updatedData.last_half = "";
      }

      // Ensure to_date is not before from_date
      if (name === "from_date" && prev.to_date && prev.to_date < value) {
        updatedData.to_date = ""; // clear invalid to_date
      }

      if (name === "to_date" && prev.from_date && value < prev.from_date) {
        alert("To Date cannot be earlier than From Date.");
        return prev; // don't update state
      }

      return updatedData;
    });
  };

  const handleApplyLeave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Clear previous errors
    setFormErrors({});

    // Validate description length
    if (formData.reason.length > 200) {
      setFormErrors({ reason: "Description must not exceed 200 characters" });
      setLoading(false);
      return;
    }

    try {
      await axios.post(
        "https://hrmspayroll.prepstripe.com/api/od-requests",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setCurrentPage(1);
      fetchODRequests(1);
      setNotification({
        message: `OD Leave applied successfully`,
        type: "success",
      });
      setFormErrors({});
      setIsApplyModalOpen(false);
      resetForm();
    } catch (err) {
      if (err.response) {
        // Handle validation errors from API
        if (err.response.data.errors) {
          setFormErrors(err.response.data.errors);
        } else {
          setError(
            err.response.data.error ||
              err.response.data.message ||
              "Failed to Apply OD leave.",
          );
        }
      } else {
        setError("Failed to Apply OD leave. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // Handle edit leave
  const handleEditLeave = async (updatedLeave, event) => {
    if (event) event.preventDefault();

    // Clear previous errors
    setFormErrors({});

    // Validate description length
    if (updatedLeave.reason && updatedLeave.reason.length > 200) {
      setFormErrors({ reason: "Description must not exceed 200 characters" });
      return;
    }

    try {
      // If from_date and to_date are the same, reset last_day and last_half
      if (updatedLeave.from_date === updatedLeave.to_date) {
        updatedLeave.last_day = "";
        updatedLeave.last_half = "";
      }

      const response = await axios.put(
        `https://hrmspayroll.prepstripe.com/api/od-requests/${updatedLeave.id}`,
        updatedLeave,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setRequests((prevLeaves) =>
        prevLeaves.map((leave) =>
          leave.id === updatedLeave.id ? response.data : leave,
        ),
      );

      setNotification({
        message: "OD Leave updated successfully.",
        type: "success",
      });
      setFormErrors({});
      setIsEditModalOpen(false);
    } catch (err) {
      if (err.response) {
        // Handle validation errors from API
        if (err.response.data.errors) {
          setFormErrors(err.response.data.errors);
        } else {
          setNotification({
            message: `${err.response.data.error || err.response.data.message || "Failed to edit leave."}`,
            type: "error",
          });
        }
      } else {
        setNotification({
          message: "Failed to edit leave. Please try again.",
          type: "error",
        });
      }
    }
  };

  // Handle opening the edit modal
  const openEditModal = (leave) => {
    setSelectedLeave(leave);
    setTimeout(() => {
      setIsEditModalOpen(true);
    }, 100); // Ensures modal updates correctly
  };

  // Delete leave
  const handleDelete = async (id) => {
    // console.log(id, token)
    try {
      await axios.delete(
        `https://hrmspayroll.prepstripe.com/api/od-requests/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Remove the deleted request from the state
      setRequests((prevRequests) =>
        prevRequests.filter((req) => req.id !== id),
      );

      //   setNotification("OD Leave deleted successfully");
      setNotification({
        message: "OD Leave deleted successfully",
        type: "success",
      });
    } catch (error) {
      console.error("Error deleting leave:", error);
      //   setNotification("Failed to delete OD Leave");
      setNotification({
        message: `Error deleting leave:, ${error}`,
        type: "error",
      });
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setCurrentPage(newPage);
      fetchODRequests(newPage);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= pagination.totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-4 py-2 rounded-md mx-1 ${
            currentPage === i
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {i}
        </button>,
      );
    }
    return pages;
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const filtering = value !== "";
    setIsFiltering(filtering);

    if (!filtering) {
      // Search cleared, restore current page's data
      handlePageChange(currentPage); // fetchResponses will be called inside
    }
  };

  // Filtered Leaves
  const filteredLeaves =
    filter === "All"
      ? requests
      : requests.filter(
          (leave) =>
            leave.request?.status?.toLowerCase() === filter.toLowerCase(),
        );

  // Further filter by search term
  const searchedLeaves = filteredLeaves.filter((leave) => {
    if (!searchTerm) return true;
    const lowerTerm = searchTerm.toLowerCase();
    return (
      leave.from_date?.toLowerCase().includes(lowerTerm) ||
      leave.to_date?.toLowerCase().includes(lowerTerm) ||
      (leave.total_days != null &&
        leave.total_days.toString().toLowerCase().includes(lowerTerm)) ||
      leave.leave_type?.toLowerCase().includes(lowerTerm) ||
      leave.request?.status?.toLowerCase().includes(lowerTerm)
    );
  });

  const resetForm = () => {
    setFormData({
      from_date: "",
      to_date: "",
      start_day: "",
      start_half: "",
      last_day: "",
      last_half: "",
      leave_type: "OD",
      total_days: "",
      reason: "",
    });
    setFormErrors({});
  };

  const hasTempFilters = Object.values(tempFilters).some((val) => val !== "");

  return (
    <div className="p-4 sm:p-6 bg-white dark:bg-gray-900 rounded-lg">
      {/* notification compo */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}

      {/* Breadcrumb */}
      <nav class="flex flex-wrap mb-4" aria-label="Breadcrumb">
        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li>
            <div className="flex items-center">
              <Link
                to={getRoleBasedRouteLocal("/admin/attendance_management")}
                className="text-sm sm:text-md font-medium text-gray-700 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-500"
              >
                Attendance Management
              </Link>
            </div>
          </li>
          <li aria-current="page">
            <div class="flex items-center">
              <svg
                class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span class="ms-1 text-sm sm:text-md font-medium text-gray-500 md:ms-2 dark:text-gray-400">
                OD Leave
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <h2 className="text-lg sm:text-xl font-semibold mb-4 dark:text-white">
        Apply Outdoor Duty
      </h2>

      {/* <h2 className="text-xl font-semibold mb-4">Apply Outdoor Duty</h2> */}

      {/* Apply Button */}
      <div className="flex flex-col sm:flex-row gap-2 justify-between items-center mb-4">
        {/* search field */}
        <div className="relative w-full sm:w-96">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full dark:bg-black dark:text-white dark:border-gray-700 placeholder:text-xs md:placeholder:text-sm p-2 pr-8 border border-gray-300 rounded-md"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery("")}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              title="Clear search"
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
        {/* Add button at right end */}
        <button
          onClick={() => {
            const hasManager =
              user?.manager ||
              user?.reporting_to ||
              user?.manager_id ||
              user?.hod_department_id;
            const isAdminOrHR =
              roles?.includes("Admin") || roles?.includes("HR");

            if (!hasManager && !isAdminOrHR) {
              setNotification({
                message: "Manager is not allocated.",
                type: "error",
              });
              return;
            }
            setIsApplyModalOpen(true);
          }}
          className="flex items-center justify-center gap-2 bg-blue-600 font-medium hover:bg-blue-700 text-white px-4 py-2 rounded-md whitespace-nowrap"
        >
          <FaPlus /> Apply OD Leave
        </button>
      </div>

      {/* Applied Outdoor Duty Table */}
      <div className="overflow-x-auto bg-white dark:bg-gray-900 shadow-md rounded-lg">
        <table className="min-w-full table-auto md:table-fixed text-sm">
          <thead className="bg-gray-100 dark:bg-gray-800 dark:text-white">
            <tr>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                Sr No.
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                Leave Type
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                From
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                To
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                Total Days
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                Status
              </th>
              <th className="py-2 px-4 dark:text-white text-center text-xs md:text-sm text-black whitespace-nowrap">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {leaveLoading ? (
              <tr className="border-b hover:bg-gray-100 dark:hover:bg-gray-800">
                <td
                  colSpan={8}
                  className="py-2 px-4 text-xs md:text-sm whitespace-nowrap"
                >
                  <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto mb-2 mt-2"></div>
                </td>
              </tr>
            ) : searchedLeaves.length > 0 ? (
              filteredData.map((leave, index) => (
                <tr
                  key={leave.id}
                  className="border-b dark:border-gray-700 dark:hover:bg-gray-950 dark:hover:text-white dark:text-white  hover:bg-gray-100"
                >
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap font-medium">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap">
                    {leave.leave_type}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap">
                    {leave.from_date}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap">
                    {leave.to_date}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap font-semibold">
                    {leave.total_days}
                  </td>
                  <td className="py-2 px-4 dark:text-white text-center text-xs md:text-sm whitespace-nowrap">
                    <StatusBadge status={leave?.request?.status} />
                  </td>

                  <td className="p-2 flex justify-center gap-2 relative">
                    <button
                      ref={openRow === leave.id ? buttonRef : null}
                      onClick={() =>
                        setOpenRow(openRow === leave.id ? null : leave.id)
                      }
                      className="text-blue-500"
                    >
                      <MoreVertical className="w-4 h-4 text-gray-600 dark:text-gray-400" />
                    </button>

                    {openRow === leave.id && (
                      <DropdownMenu
                        buttonRef={buttonRef}
                        onClose={() => setOpenRow(null)}
                      >
                        <button
                          className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                          onClick={() => {
                            setSelectedLeave(leave);
                            setDrawerOpen(true);
                            setOpenRow(null);
                          }}
                        >
                          View
                        </button>
                        {leave.request.status === "pending" && (
                          <button
                            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                            onClick={() => {
                              openEditModal(leave);
                              setOpenRow(null);
                            }}
                          >
                            Edit
                          </button>
                        )}

                        <DeleteButton
                          style={
                            "block w-full text-red-600 text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                          }
                          onDelete={() => handleDelete(leave.id)}
                        />
                      </DropdownMenu>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="py-4 px-4 text-center text-gray-500 dark:text-white"
                >
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* pagination */}
      {!isFiltering && filteredData?.length > 0 && (
        // <ReactPaginate
        // breakLabel="..."
        // nextLabel="Next >"
        // onPageChange={(event) => handlePageChange(event.selected + 1)}
        // forcePage={currentPage - 1}
        // pageRangeDisplayed={5}
        // disabledClassName='opacity-50 cursor-not-allowed'
        // disabledLinkClassName='pointer-events-none'
        // pageCount={pagination.totalPages}
        // previousLabel="< Prev"
        // previousClassName='dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800'
        // nextClassName="dark:text-white px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800"
        // renderOnZeroPageCount={null}
        // containerClassName="flex items-center justify-center mt-4 font-poppins"
        // pageClassName="mx-1 px-3 py-1 border rounded dark:text-white font-poppins"
        // activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
        // />

        <ReactPaginate
          breakLabel="..."
          nextLabel="Next >"
          onPageChange={(event) => handlePageChange(event.selected + 1)}
          forcePage={currentPage - 1}
          pageRangeDisplayed={5}
          disabledClassName="opacity-50 cursor-not-allowed"
          disabledLinkClassName="pointer-events-none"
          pageCount={pagination.totalPages}
          previousLabel="< Prev"
          previousClassName="dark:text-white border border-gray-300 rounded-md dark:border-gray-600"
          previousLinkClassName="block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
          nextClassName="dark:text-white border border-gray-300 rounded-md dark:border-gray-600"
          nextLinkClassName="block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
          renderOnZeroPageCount={null}
          containerClassName="flex items-center justify-center mt-4 font-poppins"
          pageClassName="mx-1 border rounded dark:text-white font-poppins"
          pageLinkClassName="block w-full h-full px-3 py-1 cursor-pointer"
          activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
          activeLinkClassName="bg-blue-500 text-white dark:bg-black dark:text-white hover:bg-blue-600 dark:hover:bg-gray-900"
        />
      )}

      {/* Apply leave modal */}
      {isApplyModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-[1001] backdrop-blur-sm"
          onClick={() => {
            setIsApplyModalOpen(false);
            resetForm();
          }}
        >
          <div
            className="bg-white dark:bg-gray-900 rounded-md shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            {error && (
              <div className="mx-4 mt-4 p-3 bg-red-50 border-l-4 border-red-500 rounded flex items-center gap-3 animate-in fade-in slide-in-from-top-2 duration-300">
                <AlertTriangle className="text-red-500 shrink-0" size={18} />
                <p className="text-sm text-red-700 font-medium">{error}</p>
              </div>
            )}
            <form
              onSubmit={handleApplyLeave}
              className="bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl"
            >
              <div className="relative">
                <div className="absolute inset-0 dark:from-gray-800 dark:to-gray-850"></div>
                <div className="relative flex items-center justify-between p-3 ">
                  <div className="flex items-center space-x-3">
                    {/* <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div> */}
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white tracking-tight">
                      Apply OD
                    </h2>
                  </div>

                  {/* Enhanced close button */}
                  <button
                    type="button"
                    onClick={() => {
                      setIsApplyModalOpen(false);
                      resetForm();
                    }}
                    className="group relative p-2 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95"
                    aria-label="Close modal"
                  >
                    <X
                      size={20}
                      className="text-gray-600 transition-colors duration-200"
                    />
                    <div className="absolute inset-0 rounded-xl transition-all duration-200"></div>
                  </button>
                </div>
              </div>

              {/* modal body */}
              <div className="max-h-[80vh] dark:bg-gray-900 overflow-y-auto flex flex-col gap-y-2 rounded-lg bg-white p-4">
                {/* from/to date */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label
                      htmlFor="from_date"
                      className="block dark:text-white text-sm font-medium"
                    >
                      From Date <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      id="from_date"
                      type="date"
                      name="from_date"
                      value={formData.from_date}
                      onChange={(e) => {
                        handleChange(e);
                        if (formErrors.from_date)
                          setFormErrors({ ...formErrors, from_date: "" });
                      }}
                      min={new Date().toISOString().split("T")[0]}
                      max={
                        new Date(new Date().getFullYear(), 11, 31)
                          .toISOString()
                          .split("T")[0]
                      }
                      className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 mt-1 ${
                        formErrors.from_date
                          ? "border-red-500 focus:border-red-500"
                          : ""
                      }`}
                      required
                    />
                    {formErrors.from_date && (
                      <p className="text-sm text-red-500 mt-1 flex items-center gap-1">
                        <AlertTriangle className="w-4 h-4" />
                        {formErrors.from_date}
                      </p>
                    )}
                  </div>
                  <div>
                    <label
                      htmlFor="to_date"
                      className="block dark:text-white text-sm font-medium"
                    >
                      To Date <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      id="to_date"
                      type="date"
                      name="to_date"
                      value={formData.to_date}
                      onChange={handleChange}
                      min={
                        formData.from_date ||
                        new Date().toISOString().split("T")[0]
                      } // minimum is from_date
                      max={
                        new Date(new Date().getFullYear(), 11, 31)
                          .toISOString()
                          .split("T")[0]
                      } // end of year
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  {/* Start Day Selection */}
                  <div>
                    <label className="block dark:text-white text-sm font-medium">
                      Start Day <span className="text-red-500 ml-1">*</span>
                    </label>
                    <select
                      value={formData.start_day}
                      name="start_day"
                      onChange={handleChange}
                      required
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                    >
                      <option value="" className="text-xs">
                        Select an option
                      </option>
                      <option value="Full">Full</option>
                      <option value="Half">Half</option>
                    </select>

                    {/* Half-Day Selection for Start Day */}
                    {formData.start_day === "Half" && (
                      <div className="mt-2">
                        <label className="block dark:text-white text-sm font-medium">
                          For Half
                        </label>
                        <select
                          value={formData.start_half}
                          name="start_half"
                          onChange={handleChange}
                          required
                          className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                        >
                          <option value="" className="text-xs">
                            Select an option
                          </option>
                          <option value="First">First Half</option>
                          <option value="Second">Second Half</option>
                        </select>
                      </div>
                    )}
                  </div>

                  {/* Last Day Selection */}
                  <div>
                    <label className="block dark:text-white text-sm font-medium">
                      Last Day
                    </label>
                    <select
                      value={
                        formData.from_date === formData.to_date
                          ? ""
                          : formData.last_day
                      }
                      name="last_day"
                      onChange={handleChange}
                      required
                      disabled={formData.from_date === formData.to_date}
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                    >
                      <option value="" className="text-xs">
                        Select an option
                      </option>
                      <option value="Full">Full</option>
                      <option value="Half">Half</option>
                    </select>

                    {/* Half-Day Selection for Last Day */}
                    {formData.last_day === "Half" && (
                      <div className="mt-2">
                        <label className="block dark:text-white text-sm font-medium">
                          For Half <span className="text-red-500 ml-1">*</span>
                        </label>
                        <select
                          value={formData.last_half}
                          name="last_half"
                          onChange={handleChange}
                          required
                          className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                        >
                          <option value="" className="text-xs">
                            Select an option
                          </option>
                          <option value="First">First Half</option>
                          <option value="Second">Second Half</option>
                        </select>
                      </div>
                    )}
                  </div>
                </div>

                {/* leave type */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label className="block dark:text-white font-medium">
                      Leave Type <span className="text-red-500 ml-1">*</span>
                    </label>
                    <p className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                      OD
                    </p>
                  </div>
                  <div>
                    <label className="block dark:text-white text-sm font-medium ">
                      Total Days
                    </label>
                    <p className="p-2 dark:bg-black dark:border-gray-700 border rounded dark:text-white">
                      {total_days} days
                    </p>
                    <input
                      type="number"
                      hidden
                      value={formData.total_days}
                      name={total_days}
                      onChange={handleChange}
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                    />
                  </div>
                </div>

                {/* reason */}
                <div className="md:text-md text-sm">
                  <label className="block dark:text-white font-medium">
                    Reason <span className="text-red-500 ml-1">*</span>
                  </label>
                  <textarea
                    name="reason"
                    value={formData.reason}
                    onChange={(e) => {
                      const input = e.target.value;
                      const filteredInput = input.replace(
                        /[^a-zA-Z\s.,!?']/g,
                        "",
                      );
                      setFormData({ ...formData, reason: filteredInput });
                      // Clear error when user starts typing
                      if (formErrors.reason) {
                        setFormErrors({ ...formErrors, reason: "" });
                      }
                    }}
                    className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded ${
                      formErrors.reason
                        ? "border-red-500 focus:border-red-500"
                        : ""
                    }`}
                    required
                  />
                  <div className="flex items-center justify-between mt-1">
                    <p
                      className={`text-sm ${
                        formData.reason.length > 200
                          ? "text-red-500 font-semibold"
                          : "text-gray-500"
                      }`}
                    >
                      {formData.reason.length}/200 characters
                    </p>
                  </div>
                  {formErrors.reason && (
                    <p className="text-sm text-red-500 mt-1 flex items-center gap-1">
                      <AlertTriangle className="w-4 h-4" />
                      {formErrors.reason}
                    </p>
                  )}
                </div>
              </div>

              {/* apply & cancel buttons */}
              <div className="px-4 py-5 flex justify-end items-center gap-2">
                <button
                  type="button"
                  className="px-8 py-2 text-black hover:bg-gray-200 font-medium dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
                  // onClick={() => setIsApplyModalOpen(false)}
                  onClick={() => {
                    setIsApplyModalOpen(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 font-medium text-white px-6 py-2 rounded-md flex items-center justify-center gap-2 disabled:opacity-50"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      Applying...
                    </>
                  ) : (
                    "Apply OD"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* edit form modal */}
      {isEditModalOpen && selectedLeave && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-[1001] backdrop-blur-sm"
          onClick={() => {
            setIsEditModalOpen(false);
            resetForm();
          }}
        >
          <div
            className="bg-white dark:bg-gray-900 rounded-md shadow-xl w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            {error && (
              <div className="mx-4 mt-4 p-3 bg-red-50 border-l-4 border-red-500 rounded flex items-center gap-3 animate-in fade-in slide-in-from-top-2 duration-300">
                <AlertTriangle className="text-red-500 shrink-0" size={18} />
                <p className="text-sm text-red-700 font-medium">{error}</p>
              </div>
            )}
            {/* <h2 className="text-xl font-bold mb-4">Edit OD Request</h2> */}
            <form
              onSubmit={(e) => handleEditLeave(selectedLeave, e)}
              className="bg-white dark:bg-gray-900 sm:rounded-lg rounded-t-2xl"
            >
              <div className="relative">
                <div className="absolute inset-0  dark:from-gray-800 dark:to-gray-850"></div>
                <div className="relative flex items-center justify-between p-3 ">
                  <div className="flex items-center space-x-3">
                    {/* <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div> */}
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white tracking-tight">
                      Edit OD Request
                    </h2>
                  </div>

                  {/* Enhanced close button */}
                  <button
                    type="button"
                    onClick={() => {
                      setIsEditModalOpen(false);
                      resetForm();
                    }}
                    className="group relative p-2 rounded-xl  transition-all duration-200 hover:scale-105 active:scale-95"
                    aria-label="Close modal"
                  >
                    <X
                      size={20}
                      className="text-gray-600  transition-colors duration-200"
                    />
                    <div className="absolute inset-0 rounded-xl  transition-all duration-200"></div>
                  </button>
                </div>
              </div>

              {/* modal body */}
              <div className="max-h-[80vh] overflow-y-auto flex flex-col gap-y-2 rounded-lg bg-white dark:bg-gray-900 p-4">
                {/* from and to date */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label
                      htmlFor="from_date"
                      className="block dark:text-white text-sm font-medium"
                    >
                      From Date <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      id="from_date"
                      type="date"
                      // name="from_date"
                      value={selectedLeave.from_date}
                      onChange={(e) =>
                        setSelectedLeave({
                          ...selectedLeave,
                          from_date: e.target.value,
                        })
                      }
                      min={new Date().toISOString().split("T")[0]}
                      max={
                        new Date(new Date().getFullYear(), 11, 31)
                          .toISOString()
                          .split("T")[0]
                      }
                      required
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="to_date"
                      className="block dark:text-white text-sm font-medium"
                    >
                      To Date <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      id="to_date"
                      type="date"
                      // name="to_date"
                      value={selectedLeave.to_date}
                      onChange={(e) =>
                        setSelectedLeave({
                          ...selectedLeave,
                          to_date: e.target.value,
                        })
                      }
                      min={
                        formData.from_date ||
                        new Date().toISOString().split("T")[0]
                      } // minimum is from_date
                      max={
                        new Date(new Date().getFullYear(), 11, 31)
                          .toISOString()
                          .split("T")[0]
                      } // end of year
                      required
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2"
                    />
                  </div>
                </div>

                {/* start start half, last last half   */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label className="block dark:text-white text-sm font-medium">
                      Start Day <span className="text-red-500 ml-1">*</span>
                    </label>
                    <select
                      value={selectedLeave.start_day}
                      name="start_day"
                      onChange={handleChangeEdit}
                      required
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                    >
                      <option value="">Select an option</option>
                      <option value="Full">Full</option>
                      <option value="Half">Half</option>
                    </select>

                    {selectedLeave.start_day === "Half" ? (
                      <div className="mt-2">
                        <label className="block dark:text-white text-sm font-medium">
                          For Half <span className="text-red-500 ml-1">*</span>
                        </label>
                        <select
                          value={selectedLeave.start_half}
                          name="start_half"
                          onChange={handleChangeEdit}
                          required
                          className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                        >
                          <option value="">Select an option</option>
                          <option value="First">First Half</option>
                          <option value="Second">Second Half</option>
                        </select>
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label className="block dark:text-white text-sm font-medium">
                      Last Day
                    </label>
                    <select
                      value={
                        selectedLeave.from_date === selectedLeave.to_date
                          ? ""
                          : selectedLeave.last_day
                      }
                      name="last_day"
                      onChange={handleChangeEdit}
                      required
                      disabled={
                        selectedLeave.from_date === selectedLeave.to_date
                      }
                      className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                    >
                      <option value="">Select an option</option>
                      <option value="Full">Full</option>
                      <option value="Half">Half</option>
                    </select>

                    {selectedLeave.last_day === "Half" ? (
                      <div className="mt-2">
                        <label className="block dark:text-white text-sm font-medium">
                          For Half <span className="text-red-500 ml-1">*</span>
                        </label>
                        <select
                          value={selectedLeave.last_half}
                          name="last_half"
                          onChange={handleChangeEdit}
                          required
                          className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm"
                        >
                          <option value="">Select an option</option>
                          <option value="First">First Half</option>
                          <option value="Second">Second Half</option>
                        </select>
                      </div>
                    ) : null}
                  </div>
                </div>

                {/* leave type */}
                <div className="grid grid-cols-2 gap-4 md:text-md text-sm">
                  <div>
                    <label className="block dark:text-white font-medium">
                      Leave Type <span className="text-red-500 ml-1">*</span>
                    </label>
                    <p className="w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 border rounded p-2 text-sm">
                      OD
                    </p>
                  </div>
                  <div>
                    <label className="block dark:text-white text-sm font-medium">
                      Total Days
                    </label>
                    <p className="p-2 border dark:bg-black dark:text-white dark:border-gray-700 rounded">
                      {selectedLeave.total_days} days
                    </p>
                    <input
                      type="number"
                      hidden
                      value={selectedLeave.total_days}
                      name={total_days}
                      onChange={handleChangeEdit}
                      className="w-full border dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 rounded p-2"
                    />
                  </div>
                </div>

                {/* reason */}
                <div>
                  <label className="block dark:text-white font-medium">
                    Reason <span className="text-red-500 ml-1">*</span>
                  </label>
                  <textarea
                    name="reason"
                    value={selectedLeave.reason}
                    onChange={(e) => {
                      const input = e.target.value;
                      const filteredInput = input.replace(
                        /[^a-zA-Z\s.,!?']/g,
                        "",
                      );
                      setSelectedLeave({
                        ...selectedLeave,
                        reason: filteredInput,
                      });
                      // Clear error when user starts typing
                      if (formErrors.reason) {
                        setFormErrors({ ...formErrors, reason: "" });
                      }
                    }}
                    className={`w-full dark:bg-black dark:text-white dark:focus:outline-none dark:border-gray-700 p-2 border rounded ${
                      formErrors.reason
                        ? "border-red-500 focus:border-red-500"
                        : ""
                    }`}
                    required
                  />
                  <div className="flex items-center justify-between mt-1">
                    <p
                      className={`text-sm ${
                        selectedLeave.reason.length > 200
                          ? "text-red-500 font-semibold"
                          : "text-gray-500"
                      }`}
                    >
                      {selectedLeave.reason.length}/200 characters
                    </p>
                  </div>
                  {formErrors.reason && (
                    <p className="text-sm text-red-500 mt-1 flex items-center gap-1">
                      <AlertTriangle className="w-4 h-4" />
                      {formErrors.reason}
                    </p>
                  )}
                </div>
              </div>

              {/* submit and cancel button */}
              <div className="px-4 py-5 flex justify-end items-center gap-2">
                <button
                  type="button"
                  className="px-8 py-2 text-black hover:bg-gray-200 font-medium dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
                  // onClick={() => setIsEditModalOpen(false)}
                  onClick={() => {
                    setIsEditModalOpen(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 font-medium text-white px-10 py-2 rounded-md"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Details Modal */}
      {drawerOpen && selectedLeave && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[1001] p-4"
          onClick={() => setDrawerOpen(false)}
        >
          <div
            className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in fade-in zoom-in duration-200 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="px-6 py-4 border-b dark:border-gray-800 flex justify-between items-center bg-white dark:bg-gray-900">
              <h2 className="text-xl font-bold text-gray-800 dark:text-white flex items-center">
                Request Details
              </h2>
              <button
                type="button"
                onClick={() => setDrawerOpen(false)}
                className="p-2 hover:bg-gray-200 dark:hover:bg-gray-800 rounded-full transition-colors text-gray-500"
                aria-label="Close modal"
              >
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div className="p-6">
              {/* Info Cards Grid */}
              <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-6 border dark:border-gray-700/50 mb-6 font-poppins">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Top Section: Employee & Status */}
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mr-4">
                        <svg
                          className="w-5 h-5 text-blue-600 dark:text-blue-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">
                          Employee
                        </p>
                        <p className="text-base font-medium text-gray-900 dark:text-white">
                          {user?.name || "Employee"}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-lg bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center mr-4">
                        <svg
                          className="w-5 h-5 text-emerald-600 dark:text-emerald-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">
                          Status
                        </p>
                        <div className="mt-0.5">
                          <StatusBadge
                            status={selectedLeave.request?.status || "pending"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Top Section: Leave Type & Total Days */}
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center mr-4">
                        <svg
                          className="w-5 h-5 text-orange-600 dark:text-orange-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">
                          Leave Type
                        </p>
                        <p className="text-base font-medium text-gray-900 dark:text-white">
                          {selectedLeave.leave_type}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center">
                      <div className="w-10 h-10 rounded-lg bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center mr-4">
                        <svg
                          className="w-5 h-5 text-pink-600 dark:text-pink-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold">
                          Total Days
                        </p>
                        <p className="text-base font-medium text-gray-900 dark:text-white">
                          {selectedLeave.total_days}{" "}
                          {selectedLeave.total_days === "1" ? "Day" : "Days"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Bottom Section: From & To Dates */}
                  <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t dark:border-gray-700/50">
                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border dark:border-gray-700/50">
                      <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold mb-1">
                        From Date
                      </p>
                      <p className="text-base font-medium text-gray-900 dark:text-white">
                        {selectedLeave.from_date}
                      </p>
                      {selectedLeave.start_day && (
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                          <span className="font-medium">
                            {selectedLeave.start_day}
                          </span>{" "}
                          Day
                          {selectedLeave.start_day === "Half" &&
                            selectedLeave.start_half &&
                            ` (${selectedLeave.start_half} Half)`}
                        </p>
                      )}
                    </div>

                    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border dark:border-gray-700/50">
                      <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wider font-semibold mb-1">
                        To Date
                      </p>
                      <p className="text-base font-medium text-gray-900 dark:text-white">
                        {selectedLeave.to_date}
                      </p>
                      {selectedLeave.last_day && (
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                          <span className="font-medium">
                            {selectedLeave.last_day}
                          </span>{" "}
                          Day
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="text-sm font-bold text-blue-800 dark:text-blue-300 mb-2 flex items-center">
                    Reason for Leave
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
                    {selectedLeave.reason ||
                      "No reason provided for this request."}
                  </p>
                </div>

                {selectedLeave.request?.status !== "pending" && (
                  <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border dark:border-gray-700">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="text-sm font-bold text-gray-800 dark:text-gray-200">
                        Approver Comments
                      </h3>
                      {selectedLeave.request.action_date && (
                        <span className="text-[10px] text-gray-400">
                          {selectedLeave.request.action_date}
                        </span>
                      )}
                    </div>
                    <p className="text-gray-600 dark:text-gray-400 text-sm italic">
                      {selectedLeave.request.approver_comments ? (
                        `"${selectedLeave.request.approver_comments}"`
                      ) : (
                        <span className="text-gray-400">No comments provided.</span>
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Footer with Action Buttons */}
            <div className="px-6 py-4 bg-white dark:bg-gray-900 border-t dark:border-gray-800 flex justify-between items-center">
              <div className="flex gap-3">
                <button
                  onClick={() => setDrawerOpen(false)}
                  className="px-6 py-2.5 rounded-xl border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                >
                  Close
                </button>
                {selectedLeave.request.status === "pending" && (
                  <DeleteButton
                    style="px-6 py-2.5 rounded-xl border border-red-200 text-red-600 font-medium hover:bg-red-50 transition-colors"
                    onDelete={() => {
                      handleDelete(selectedLeave.id);
                      setDrawerOpen(false);
                    }}
                    buttonText="Delete"
                  />
                )}
              </div>

              {selectedLeave.request.status === "pending" && (
                <button
                  onClick={() => {
                    setDrawerOpen(false);
                    openEditModal(selectedLeave);
                  }}
                  className="px-6 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-medium transition-all flex items-center gap-2"
                >
                  <Edit3 size={16} />
                  <span className="text-left text-sm leading-tight">
                    <span className="block">Edit</span>
                    <span className="block">Request</span>
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OutdoorDutyPage;
